export const homeHero = {
  headline: 'Welcome to Chacon’s Lawncare',
  mascotImage: 'https://cdn.magicpatterns.com/uploads/pbRXkqpcnSoMKjiWUavDy6/Friendly_Lawn_Care_Mascot_Logo.png',
  mascotAlt: 'Chacon’s Lawncare mascot waving hello next to a mower and a well-kept lawn',
};
